import React from 'react'

export default function CraftpreservationText() {
  return (
    <>
    <section className="craftpage-content">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <p>Sonam's Label empowers and embraces the essence of modern Indian elegance by working closely with artisans, tailors, and design studios rooted in heritage techniques and contemporary vision. Over the years, Sonam's Label has built its identity on a passion for craftsmanship, respect for tradition, and a deep commitment to quality and authenticity.</p>

                    <p>From exquisitely tailored ensembles that blend rich Indian textiles with modern silhouettes to bespoke couture that balances festive grandeur with understated elegance, Sonam's Label collections include bridal lehengas, occasion wear, and custom-designed garments. Every piece is created to empower women to express their individuality with poise and confidence.</p>

                    <p>At Sonam's Label, tradition meets innovation. The brand collaborates with skilled craftsmen to honor Indian textile legacies such as hand embroidery, fine silks, curated embellishments, and refined drapes, while designing garments that speak to the global woman of today. Its mission is to elevate Indian design by integrating contemporary sensibility, promoting ethical production methods, and delivering garments that feel both personal and exceptional.</p>

                    <p>Today, Sonam's Label offers a seamless experience from consultation to creation, from fabric selection to bespoke finishing touches. The brand believes in celebrating every woman’s story through fashion, whether it is a bridal moment, a festive gala, or the simplicity of refined everyday elegance. Each design is crafted to reflect emotion, joy, and style. Looking ahead, Sonam's Label envisions building a brand that bridges heritage and modernity, craftsmanship and aspiration.</p>
                </div>
            </div>
        </div>
    </section>


    <section className='craftpage-image'>
        <img src="/image/craft-image.webp" className="img-responsive wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.2s" alt="Craft" loading="lazy"/>
    </section>


    <section className="craftpage-content">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <p>Every thread spun in India carries a story of mastery. At Sonam's Label, our mission is to transform that legacy into the new voice of royal couture.</p>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
